export default __webpack_public_path__ + "static/media/img-mindmap-merchant-and-users.ca56f5e5.png";